import purify from "dompurify";

import { Stack, Text } from "@similarweb/ui-components/foundations";

import { DunningsBulletPoint } from "app/components/Dunnings/DunningsBulletPoint/DunningsBulletPoint";
import { useTranslation } from "pro-features/components/WithTranslation";

interface IReactivateAccountDunningListProps {
    listHeaderText: string;
}

export const ReactivateAccountDunningList = ({ listHeaderText }: IReactivateAccountDunningListProps) => {
    const translate = useTranslation();

    return (
        <Stack gap="8px">
            <Text
                fontVariant="body2"
                type="DM Sans"
                dangerouslySetInnerHTML={{
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    __html: purify.sanitize(listHeaderText),
                }}
            />

            <DunningsBulletPoint text={translate("dunnings.restartTrial.modal.bullet_1")} />

            <DunningsBulletPoint text={translate("dunnings.restartTrial.modal.bullet_2")} />

            <DunningsBulletPoint text={translate("dunnings.restartTrial.modal.bullet_3")} />
        </Stack>
    );
};
